// This module exposes a very thin proxy object to be used in place of the 'window.location'
// property, primarily so that navigation may stubbed in unit tests, since window.location
// itself cannot be redefined / stubbed in real browsers.
//
// The locator object exported here currently supports a minimal subset of
// window.location properties.  In particular you cannot assign or .assign directly
// to locator as you would to location, but should instead assign to the locator.href
// property.
const locatorClient = {
  get search() {
    return window.location.search;
  },
};

export default locatorClient;
